export const PDP_DEATAIL = "product details"
export const PDP_VIEW = "view this product in your space"
export const PDP = "pdp"
export const NAVIGATION = "navigation"
export const CROSS_SELL = "cross-sell"
export const BASED_ON_LOCATION = "based on your current location"
export const ADD_INSTALL = "add an install service"
export const PURCHASE_DESIGN = "purchase a design plan"
export const STORE_NEAR = "see product on display"
export const FIND_PRO = "find a local pro"
export const WAIT_TIME_FOR_DATALAYER = 5000
export const ADD_TO_CART = "add to cart"
export const PRODUCT_DECS = "flat fee pricing. kohler trusted professionals."
export const PRODUCT_TYPE = "regular w/required Items"
export const PRODUCT_INSATLL = "install service"
